import React from "react";
import useMetaTags from "../../hooks/useMetaTags"; // Adjust path based on your project structure

const WhyChooseOrganicPads = () => {

  useMetaTags({
    title: "Why Choose Organic Pads? Benefits & Guide",
    description: "Discover why organic sanitary pads are better for your health and the environment. Learn about their benefits, materials, and how to choose the right one.",
    keywords: "organic pads, sanitary napkins, eco-friendly period products, chemical-free pads, biodegradable sanitary napkins",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "/why-choose-organic-pads",
    ogTitle: "Why Choose Organic Pads?",
    ogDescription: "Find out the benefits of organic sanitary pads and why they are a safer choice for women.",
    ogImage: "https://organicpads.shop/logo.png",
    ogUrl: "https://organicpads.shop/why-choose-organic-pads",
    ogType: "article",
    twitterCard: "summary_large_image",
    twitterTitle: "Why Organic Pads Are Better for Women",
    twitterDescription: "Learn why organic pads are healthier and better for the environment.",
    twitterImage: "https://organicpads.shop/logo.png",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
  });

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "/why-choose-organic-pads"
    },
    "headline": "Why Choose Organic Pads? Benefits & Guide",
    "description": "Discover why organic sanitary pads are better for your health and the environment. Learn about their benefits, materials, and how to choose the right one.",
    "image": "/logo.png",
    "author": {
      "@type": "Organization",
      "name": "Organic Pads",
      "url": "/"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Organic Pads",
      "logo": {
        "@type": "ImageObject",
        "url": "/logo.png"
      }
    },
    "datePublished": "2025-02-23",
    "dateModified": "2025-02-23",
    "keywords": [
      "organic pads",
      "sanitary napkins",
      "eco-friendly period products",
      "chemical-free pads",
      "biodegradable sanitary napkins"
    ]
  };

  return (
    <>
      <div className="max-w-4xl mx-auto px-6 mt-20 py-8">
        <h1 className="text-4xl font-bold mb-6 text-center">Why Choose Organic Pads?</h1>
        <img
          src="https://images.unsplash.com/photo-1712842955521-55c8c01ef148?w=600"
          alt="Organic Pads Logo"
          className="w-full h-auto rounded-lg mb-6"
        />

        <p className="text-lg mb-6">
          Organic pads are a natural alternative to conventional sanitary pads, offering a safer and eco-friendly option for menstrual hygiene. Unlike mainstream pads that often contain synthetic chemicals, plastics, and fragrances, organic pads are made from 100% natural materials, making them better for your body and the environment.
        </p>

        <h2 className="text-3xl font-semibold mt-8 mb-4">Benefits of Organic Pads</h2>
        <ul className="list-disc ml-8 text-lg mb-6">
          <li><strong>Hypoallergenic:</strong> Free from chemicals, dyes, and fragrances that may cause skin irritation.</li>
          <li><strong>Biodegradable:</strong> Breaks down naturally, reducing plastic waste.</li>
          <li><strong>Breathable & Comfortable:</strong> Natural cotton allows better airflow, reducing discomfort.</li>
          <li><strong>Free from Harmful Chemicals:</strong> No chlorine, pesticides, or synthetic fragrances.</li>
          <li><strong>Highly Absorbent:</strong> Designed to handle various flow levels efficiently.</li>
        </ul>

        <h2 className="text-3xl font-semibold mt-8 mb-4">How to Choose the Right Organic Pad?</h2>
        <p className="text-lg mb-6">
          When selecting an organic pad, consider factors like absorbency, certification, and comfort. Look for certifications such as:
        </p>
        <ul className="list-disc ml-8 text-lg mb-6">
          <li><strong>GOTS (Global Organic Textile Standard):</strong> Ensures the cotton used is truly organic.</li>
          <li><strong>Oeko-Tex Certification:</strong> Guarantees no harmful substances are present.</li>
          <li><strong>Biodegradability:</strong> Choose pads that decompose faster than regular pads.</li>
        </ul>

        <img
          src="https://plus.unsplash.com/premium_photo-1702598576513-fe7425ebf6bd?w=600"
          alt="Eco-friendly sanitary pads"
          className="w-full h-auto rounded-lg mb-6"
        />

        <h2 className="text-3xl font-semibold mt-8 mb-4">Final Thoughts</h2>
        <p className="text-lg mb-6">
          Making the switch to organic pads is an empowering step toward better health and environmental sustainability. By choosing organic, you are reducing your exposure to toxins, supporting ethical brands, and minimizing your carbon footprint. <strong>Try them today and experience the difference!</strong>
        </p>
      </div>

      {/* Schema Markup */}
      <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </>
  );
};

export default WhyChooseOrganicPads;
